export const eventListActions = {
    SET_EVENTLIST: 'SET_EVENTLIST'
};

const eventlistreducer = (state, action) => {
    switch (action.type) {
        case eventListActions.SET_EVENTLIST:
            return {
                ...state,
                projectList: action.projectList,
            };
        default:
            return {
                state
            };
    }
};

export default eventlistreducer;